import type { HelpFile } from '../../types/help'
import { RevokeApiKeyDialogTestIds } from '../../../testids/RevokeApiKeyDialogTestIds'

export const revokeApiKeyDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [RevokeApiKeyDialogTestIds.revokeDialogTitle]: null,
    [RevokeApiKeyDialogTestIds.revokeDialogBody]: null,
    [RevokeApiKeyDialogTestIds.btnCancelRevokeKey]:
      'Close the dialog without revoking the key.',
    [RevokeApiKeyDialogTestIds.btnConfirmRevokeKey]:
      'Permanently revoke this API key. Authentication using the key fails immediately. Idempotent — re-revoking shows the same success toast.',
  },
}
